/*eslint-disable */
import { findIndex, find } from 'lodash';
import { useContext, useEffect, useState } from 'react';
import useFetchData from '../../../hooks/useFetchData';
import Product from './product';
import translating from '../translate.json';
import Button from '../../Button';
import Api from '../../../utils/api';
import BasicModal from './Modal/basic-modal';
import enumPaymentStatus from '../../../enums/enum-payment-status';
import PropTypes from 'prop-types';
import BasicDialog from 'components/Dialog';
import GlobalContext from 'contexts';
import SnackBarComp from 'components/SnackBar';

const Shop = ({ handleChangeMode, organizationId }) => {
  const { data: productsList } = useFetchData(
    `product/findByOrganiztion/${organizationId}`
  );
  const [openModal, setOpenModal] = useState(false);
  const [removeIndex, setRemoveIndex] = useState();
  const { currentCustomer } = useContext(GlobalContext);
  const [cart, setCart] = useState([]);
  const [paymentId, setPaymentId] = useState(null);
  const [paymentUrl, setPaymentUrl] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);

  const [openModalFreeProduct, setOpenModalFreeProduct] = useState();

  const discount = [
    { id: '1', name: 'אחוז' },
    { id: '2', name: 'מחיר קבוע' }
  ];

  let productsCount = cart.reduce((prev, cur) => {
    return prev + cur.quantity;
  }, 0);

  let productsPrice = cart
    .reduce((prev, cur) => {
      return prev + Number(cur.price);
    }, 0)
    .toFixed(2);

  let totalDiscount = cart
    .reduce((prev, cur) => {
      return prev + Number(cur.price - cur.total);
    }, 0)
    .toFixed(2);

  // useEffect(() => {
  //     if (paymentId) {
  //         const checkStatusInterval = setInterval(() => {
  //             checkPaymentStatus(paymentId);
  //         }, 2000);

  //         return () => clearInterval(checkStatusInterval);
  //     }
  // }, [paymentId]);

  // async function checkPaymentStatus(paymentId) {
  //     const res = await Api.get(`/payment/get_payment_status/${paymentId}`);
  //     const { paymentStatus } = res.data;

  //     console.log('Payment Status: ' + paymentStatus);

  //     if (paymentStatus === enumPaymentStatus.PaymentExpired) onPaymentExpired();
  //     if (paymentStatus === enumPaymentStatus.PaymentSuccessful) onPaymentSuccess();
  //     if (paymentStatus === enumPaymentStatus.PaymentFailed) onPaymentFail();
  // }

  function clearPaymentData() {
    setPaymentId(null);
    // setPaymentUrl(null);
  }

  function onClosePaymentModal() {
    clearPaymentData();
    handleChangeMode(null);
  }

  function onPaymentExpired() {
    clearPaymentData();
    alert(enumPaymentStatus.PaymentExpired);
    // TODO
  }

  function onPaymentSuccess() {
    clearPaymentData();
    console.log(enumPaymentStatus.PaymentSuccessful);
    setPaymentUrl(null);
    setShowSnackbar(true);
  }

  function onPaymentFail() {
    clearPaymentData();
    alert(enumPaymentStatus.PaymentFailed);
    // TODO
  }

  const buy = (isFreeProduct) => {
    if (cart.length === 0) return;

    let cartWithoutTotal = JSON.parse(JSON.stringify(cart));

    cartWithoutTotal = cartWithoutTotal.map((item) => {
      delete item.total;
      return item;
    });

    const purchase = {
      createClientProductDto: cartWithoutTotal
    };
    Api.post('/client-product/create-multiple-client-products', purchase).then(
      (res) => {
        const { payment_id: paymentId, payment_url: paymentUrl } = res.data;
        setPaymentId(paymentId);
        if (!isFreeProduct) setPaymentUrl(paymentUrl);
        else setOpenModalFreeProduct(true);
      }
    );
  };

  const removeItem = () => {
    let tmpCart = [...cart];
    tmpCart.splice(removeIndex, 1);
    setCart(tmpCart);
    setRemoveIndex(null);
    setOpenModal(false);
  };

  const saveToCart = (
    item,
    count,
    discountType,
    discountValue,
    total,
    updated
  ) => {
    let tmpCart = [...cart];
    const index = findIndex(tmpCart, { productId: item?.id });
    const currentProduct = {
      clientId: currentCustomer.id,
      productId: item.id,
      quantity: count,
      discountType: find(discount, { id: discountType })?.name,
      discountValue: discountValue,
      total: total,
      price: item.price
    };
    if (index > -1) {
      if (updated) {
        tmpCart[index] = currentProduct;
      } else {
        setRemoveIndex(index);
        setOpenModal(true);
      }
    } else tmpCart.push(currentProduct);
    setCart(tmpCart);
  };

  const handleSubmitAddFreeProduct = () => {
    Api.post(`/client-product/activate-client-product/${paymentId}`).then(
      (res) => {
        if (res?.data?.success === true) window.location.reload();
      }
    );
  };

  return (
    <>
      {productsList && (
        <div className="shop">
          <div className="products-list">
            {productsList?.map((product, index) => (
              <Product
                key={index}
                product={product}
                discount={discount}
                handleAction={saveToCart}
                isInCart={find(cart, { productId: product.id })}
              ></Product>
            ))}
          </div>
          {cart.length ? (
            <div className="sub-total">
              <div className="sub">{`${translating.subTotal}  ${productsCount} ${translating.products}`}</div>
              {cart.map((item, index) => (
                <div key={index} className="sub">
                  {item.quantity}{' '}
                  {find(productsList, { id: item.productId })?.name} במחיר{' '}
                  {item.total} ₪
                </div>
              ))}
              <div className="sub">
                <span>{`לפני הנחה: ${productsPrice} ₪    `}</span>
              </div>
              <div className="sub">
                <span>{` הנחה: ${totalDiscount} ₪    `}</span>
              </div>

              <div className="sub">
                <span>{`סה'כ לתשלום: ${
                  productsPrice - totalDiscount
                } ₪    `}</span>
              </div>
            </div>
          ) : (
            ''
          )}
          {cart?.length ? (
            <div className="payment-area">
              <Button
                handleClick={() => {
                  if (productsPrice - totalDiscount > 0) buy();
                  else buy(true);
                }}
                txt={translating.payNow}
              ></Button>
            </div>
          ) : (
            ''
          )}
          {openModal && (
            <BasicDialog
              title={translating.removeTitle}
              description={translating.removeDescription}
              handleClose={() => setOpenModal(false)}
              handleSubmit={removeItem}
            ></BasicDialog>
          )}

          {openModalFreeProduct && (
            <BasicDialog
              title={'הוספת מוצר חינמי'}
              description={
                'האם אתה בטוח שאתה רוצה להוסיך ללקוח את המוצר ללא תשלום?'
              }
              handleClose={() => setOpenModalFreeProduct(false)}
              handleSubmit={handleSubmitAddFreeProduct}
            ></BasicDialog>
          )}

          {paymentUrl && (
            <BasicModal
              width={800}
              height={`80%`}
              handleClose={onClosePaymentModal}
            >
              <iframe className="payment-iframe" src={paymentUrl} />
            </BasicModal>
          )}

          {showSnackbar && (
            <SnackBarComp
              msg="מוצר נרכש בהצלחה"
              handleClose={() => window.location.reload()}
            ></SnackBarComp>
          )}
        </div>
      )}
    </>
  );
};

export default Shop;

Shop.propTypes = {
  handleChangeMode: PropTypes.func,
  organizationId: PropTypes.string
};
